import React from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  YAxis,
} from 'recharts';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import { generateTitleAndSource } from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';

export const ActivePopulation: React.FC = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { activePopulationFormattedData } = useSocioeconomicChartsData();
  const { innerWidth } = window;
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.activePopulation.pea,
        nls.disclaimers.dataSourceIBGE2010
      )}
      extraClasses="relative paddingTop"
    >
      {errorFetchData?.activePopulation ? (
        <ErrorState />
      ) : (
        <>
          <ResponsiveContainer
            width={innerWidth < 1439 ? '90%' : '40%'}
            height="85%"
          >
            <BarChart
              width={500}
              height={300}
              data={activePopulationFormattedData}
            >
              <CartesianGrid />
              <YAxis />
              <Bar dataKey="workers" stackId="a" fill="#925AC4" />
              <Bar dataKey="inactivePopulation" stackId="a" fill="#BBC1C9" />
            </BarChart>
          </ResponsiveContainer>
          <div className="socioeconomic-legend-inactive-population">
            <div className="legend-container">
              <div
                className="shape-circle"
                style={{ backgroundColor: '#925AC4' }}
              />
              <p>
                {nls.charts.activePopulation.workers}{' '}
                {activePopulationFormattedData[0]?.labels?.workers}
              </p>
            </div>
            <div className="legend-container">
              <div
                className="shape-circle"
                style={{ backgroundColor: '#BBC1C9' }}
              />
              <p>
                {nls.charts.activePopulation.inactivePopulation}{' '}
                {activePopulationFormattedData[0]?.labels?.inactivePopulation}
              </p>
            </div>
            <div>
              <p>
                {nls.charts.activePopulation.totalPea}{' '}
                {activePopulationFormattedData[0]?.labels?.total}
              </p>
            </div>
          </div>
        </>
      )}
    </GenericChartCard>
  );
};
